import { useState } from 'react';

export const useFormattedNumber = (initialValue = '') => {
  const [value, setValue] = useState(initialValue);
  const [formatted, setFormatted] = useState('');

  const formatNumber = (val) => {
    // Remove any non-digit characters except decimal point
    const rawValue = val.replace(/[^\d.]/g, '');
    
    // Handle decimal points
    const parts = rawValue.split('.');
    if (parts.length > 2) return formatted; // Don't allow multiple decimal points
    
    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Format integer part with commas
    let formattedInteger = '';
    if (integerPart) {
      formattedInteger = parseInt(integerPart).toLocaleString('en-US');
    }

    // Combine with decimal part if it exists
    if (decimalPart !== undefined) {
      return `${formattedInteger}.${decimalPart}`;
    }

    return formattedInteger;
  };

  const onChange = (e) => {
    const input = e.target.value;
    // Store raw value (digits only)
    const rawValue = input.replace(/[^\d.]/g, '');
    setValue(rawValue);
    
    // Update formatted display value
    const newFormatted = formatNumber(input);
    if (newFormatted !== '') {
      setFormatted(newFormatted);
    } else {
      setFormatted('');
    }
  };

  return {
    value, // Raw value for form submission
    formatted, // Formatted value for display
    onChange
  };
};
